module.exports = __webpack_public_path__ + "img/sebrae-logo.29049cad.png";